/**
 * Dynamic API URL resolution for LAN/mobile access.
 * Uses the browser's current hostname so the app works from any device
 * on the network without needing to change .env files.
 */

function isUsableEnvUrl(envVar: string | undefined): envVar is string {
  if (envVar && !envVar.includes('localhost')) {
    return true;
  }
  return false;
}

function normalizeApiBaseUrl(url: string): string {
  return url.replace(/\/+$/, '').replace(/\/api(\/v1)?$/, '');
}

function resolveApiUrl(envVar: string | undefined, fallbackPort: number): string {
  if (isUsableEnvUrl(envVar)) return normalizeApiBaseUrl(envVar);

  const hostname = window.location.hostname;
  const isSecureOrigin = window.location.protocol === 'https:';
  if (isSecureOrigin) return '';

  return `http://${hostname}:${fallbackPort}`;
}

function resolveWsUrl(envVar: string | undefined, fallbackPort: number): string {
  if (isUsableEnvUrl(envVar)) return envVar;

  const hostname = window.location.hostname;
  const isSecureOrigin = window.location.protocol === 'https:';
  if (isSecureOrigin) return `wss://${window.location.host}/notifications/ws`;

  return `ws://${hostname}:${fallbackPort}/ws`;
}

export const API_URL = resolveApiUrl(process.env.REACT_APP_API_URL, 8080);
export const API_BASE_URL = resolveApiUrl(process.env.REACT_APP_API_BASE_URL, 8080);
export const WS_URL = resolveWsUrl(process.env.REACT_APP_WS_URL, 8084);
